import { $fetch, $put, $post } from '@/services/axios';

export function fetch() {
  return $fetch(`market/currencies`);
}

export function add(data) {
  return $put(`market/currency`, data);
}

export function sort(data) {
  return $post(`market/currencies/sort`, data);
}

export function validate(data) {
  return $post(`market/currency/validate`, data);
}

export function edit(data) {
  return $post(`market/currency/${data.id}`, data);
}
